<script setup lang="ts">
import { useDynamicDialogs } from './dynamicDialog.ts';
import { Spinner } from '../spinner';
import { DialogOverlay, DialogPortal } from 'radix-vue';
import { Dialog } from '@/components/ui/dialog';

const dialogs = useDynamicDialogs();

defineSlots<{
  fallback: void;
}>();
</script>

<template>
  <Dialog
    v-for="dialog in dialogs.activeDialogs"
    :key="dialog.id"
    :open="dialog.isOpen.value"
    @update:open="
      (newOpen: boolean) => {
        if (!newOpen) {
          dialog.close();
        }
      }
    "
  >
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
      >
        <Suspense>
          <component :is="dialog.component" v-bind="dialog.props" />

          <template #fallback>
            <slot name="fallback">
              <div
                class="w-24 h-24 bg-white rounded-lg flex items-center justify-center"
              >
                <Spinner class="w-8 h-8 !fill-primary" />
              </div>
            </slot>
          </template>
        </Suspense>
      </DialogOverlay>
    </DialogPortal>
  </Dialog>
</template>
